import { useState } from 'react';

import { GroupedOption } from '../../../hooks/useRiderOptions';

export function useValidateDashcamForMixedRiders() {
  const [openDashcamNotificationModal, setDashcamNotificationModal] = useState(false);

  const hasDashcamConflicts = (ridersOnRide: GroupedOption[]) => {
    const hasDashcamRider = ridersOnRide.some((rider) => rider.services?.some((service) => service.code === 'DR'));
    const hasNonDashcamRider = ridersOnRide.some((rider) => !rider.services?.some((service) => service.code === 'DR'));

    if (hasDashcamRider && hasNonDashcamRider) {
      setDashcamNotificationModal(true);

      return true;
    }

    return false;
  };

  const closeDashcamNotificationModal = () => {
    setDashcamNotificationModal(false);
  };

  return {
    openDashcamNotificationModal,
    hasDashcamConflicts,
    closeDashcamNotificationModal,
  };
}
